export const getRandomString = (length, characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789") => {
    let result = "";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
};

export const setTheme = (featureData) => {
    document.documentElement.style.setProperty(
        "--startGradient",
        featureData?.cardGrad1
    );
    document.documentElement.style.setProperty(
        "--endGradient",
        featureData?.cardGrad2
    );
    document.documentElement.style.setProperty(
        "--lightstartGradient",
        featureData?.cardGrad1 + "20"
    );
    document.documentElement.style.setProperty(
        "--lightendGradient",
        featureData?.cardGrad2 + "20"
    );
    document.documentElement.style.setProperty("--textColor", featureData?.text);
};
